export function colourHierarchy(props) {
    if (props.inherit) {
        return "inherit";
    }

    if (props.tertiary) {
        return props.theme.tertiary;
    }

    if (props.secondary) {
        return props.theme.secondary;
    }

    return props.theme.primary;
}

export function imageBlobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject();
        reader.readAsDataURL(blob);
    });
}
